import { render, staticRenderFns } from "./RegChagasEdit.vue?vue&type=template&id=1e92f4d4"
import script from "./RegChagasEdit.vue?vue&type=script&lang=js"
export * from "./RegChagasEdit.vue?vue&type=script&lang=js"
import style0 from "./RegChagasEdit.vue?vue&type=style&index=0&id=1e92f4d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports